import { render } from "./gang-add-comment.vue?vue&type=template&id=c66a989a"
import script from "./gang-add-comment.vue?vue&type=script&lang=js"
export * from "./gang-add-comment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__